import { connect } from 'react-redux';
import ModalTransferAnotherCard from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(ModalTransferAnotherCard);
